import React, { useRef, useState, useEffect } from 'react';
import { createPortal } from 'react-dom';

const InfoTooltip = ({
  children,
  content,
  title = "Learn More",
  position = "top",
  size = "sm",
  className = "",
  iconClassName = "",
  isDarkMode = false,
  underline = true
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [tooltipPosition, setTooltipPosition] = useState({ top: 0, left: 0 });
  const triggerRef = useRef(null);
  const tooltipRef = useRef(null);

  useEffect(() => {
    if (isOpen && triggerRef.current) {
      const rect = triggerRef.current.getBoundingClientRect();
      setTooltipPosition({
        top: rect.top - 8,
        left: rect.left + rect.width / 2
      });
    }
  }, [isOpen]);

  const sizeClasses = {
    sm: "min-w-48 max-w-80",
    md: "min-w-56 max-w-96",
    lg: "min-w-64 max-w-112",
    xl: "min-w-72 max-w-128"
  };

  const tooltipContent = isOpen && createPortal(
    <div
      ref={tooltipRef}
      className={`fixed z-[9999] ${sizeClasses[size]} pointer-events-none`}
      style={{
        top: tooltipPosition.top,
        left: tooltipPosition.left,
        transform: 'translateX(-50%) translateY(-100%)',
        transformOrigin: 'bottom center'
      }}
      onMouseEnter={() => setIsOpen(true)}
      onMouseLeave={() => setIsOpen(false)}
    >
      <div className={`relative ${isDarkMode ? 'bg-gray-800' : 'bg-gray-100'} border ${isDarkMode ? 'border-gray-700' : 'border-gray-300'} rounded-lg shadow-xl p-3 pointer-events-auto`}>
        <div className={`text-sm ${isDarkMode ? 'text-gray-300' : 'text-gray-700'} leading-relaxed whitespace-normal break-words`}>
          {typeof content === 'string' ? (
            content.split('\n').map((line, index) => (
              <div key={index} className="text-center">
                {line}
              </div>
            ))
          ) : (
            content
          )}
        </div>
        {/* Arrow */}
        <div className={`absolute w-2 h-2 ${isDarkMode ? 'bg-gray-800' : 'bg-gray-100'} border ${isDarkMode ? 'border-gray-700' : 'border-gray-300'} transform rotate-45 left-1/2 -translate-x-1/2 top-full -mt-1 border-l-0 border-b-0`}></div>
      </div>
    </div>,
    document.body
  );

  return (
    <span ref={triggerRef} className={`relative inline-block ${className}`}>
      <span
        className={`cursor-help ${underline ? 'border-b' : ''} ${isDarkMode ? 'border-gray-500 hover:border-gray-400' : 'border-gray-400 hover:border-gray-600'} transition-colors duration-200`}
        onMouseEnter={() => setIsOpen(true)}
        onMouseLeave={() => setIsOpen(false)}
      >
        {children}
      </span>
      {tooltipContent}
    </span>
  );
};

export default InfoTooltip; 